export class Favorite {
  constructor(
    public name: string,
    public rating: string,
    public price: string
  ) {}
}



// WEBPACK FOOTER //
// /Users/kaitlynfujihara/Desktop/keiken/src/app/models/favorite.model.ts